import { RouterProvider } from "react-router";
import { Toaster } from "sonner";
import "./i18n";
import { clientRouter } from "./routes/client";
import { PwaInstallBanner } from "./components/PwaInstallBanner";

export default function ClientApp() {
  return (
    <>
      <RouterProvider router={clientRouter} />
      <Toaster
        position="top-center"
        richColors
        offset={12}
        visibleToasts={2}
        duration={2200}
        closeButton
      />
      <PwaInstallBanner />
    </>
  );
}
